var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('h2',[_vm._v("Settings")]),_c('hr'),(_vm.can('access-dealer-profile'))?_c('DealerProfile'):_vm._e(),_c('MyProfile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }